import { FC } from 'react';
import Hero from 'src/for-owners/components/Hero';
import ToolList from 'src/for-owners/components/ToolList';
import Recommendations from 'src/for-owners/components/Recommendations';
import FAQs from 'src/for-owners/components/FAQs';
import Footer from 'src/for-owners/components/Footer';

const ForOwnersRoot: FC = () => (
  <main>
    <Hero />
    <ToolList />
    <Recommendations />
    <FAQs />
    <Footer />
  </main>
);

export default ForOwnersRoot;
